import React from 'react'
import Layout from '../views/Layout'
import SEO from '../views/Seo'
import { parseAcfHead, parseSeo } from '../helpers/seo'
import { PageContent } from '../components/PageContent'
import { Breadcrumbs } from '../components/Breadcrumbs'
import { WpBlocksGenerator } from '../helpers/wpBlocksGenerator'
import { Section } from '../components/Section'
import { graphql } from 'gatsby'
import { Heading } from '../components/Heading'
import { COLORS } from '../helpers/constants'
import { Divider } from '../components/Divider'
import { Container } from '../components/Container'
import { stripTags } from '../helpers/texts'

export default ({ data }) => {
  const page = data.wordpress.faq
  const { title, blocks = [], seo, excerpt, acfHead } = page
  const { schema, hrefLangs } = parseAcfHead(acfHead)
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: title,
        acceptedAnswer: { '@type': 'Answer', text: stripTags(excerpt) },
      },
    ],
  }
  return (
    <Layout>
      <SEO {...parseSeo(seo)} schema={schema ? schema : faqSchema} hrefLangs={hrefLangs} />
      <PageContent>
        <Breadcrumbs breadcrumbs={seo.breadcrumbs} />
        <Section indented>
          <Container>
            <Heading color={COLORS.RED} align={'center'} type={'h1'}>
              {title}
            </Heading>
            <Divider />
            <WpBlocksGenerator blocks={blocks} post={page} container={false} />
          </Container>
        </Section>
      </PageContent>
    </Layout>
  )
}

export const query = graphql`
  query($id: ID!) {
    wordpress {
      faq(id: $id) {
        ...Single_Faq
      }
    }
  }
`
